export default __webpack_public_path__ + "static/revolutionizing-healthcare-with-implementation-d4d0e7fa15e7cc1b1ecc1230dbcd60b9.png";